function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_909",
  "data-name": "Group 909",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_682",
  "data-name": "Group 682",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M230.024-168.75a2.708,2.708,0,0,0-2.9-2.468h-12.21a2.709,2.709,0,0,0-2.9,2.468v15.79a2.709,2.709,0,0,0,2.9,2.468h12.21a2.708,2.708,0,0,0,2.9-2.468Z",
  transform: "translate(-212.024 174.048)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M220.819-175.665h11.117v-2.785H220.819Z",
  transform: "translate(-217.377 178.45)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M220.819-116.109h11.117v-.7H220.819Z",
  transform: "translate(-217.377 140.761)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M212.168-162.192h17.888",
  transform: "translate(-212.112 168.511)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  "data-name": "Path 498",
  d: "M212.168-127.273h17.888",
  transform: "translate(-212.112 147.132)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_587",
  "data-name": "Path 587",
  d: "M229.666-149.994s1.956,3.009,1.956,4.09a1.957,1.957,0,0,1-1.956,1.956,1.958,1.958,0,0,1-1.957-1.956C227.709-146.985,229.666-149.994,229.666-149.994Z",
  transform: "translate(-220.665 160.346)",
  fill: "#48b05e",
  fillRule: "evenodd"
}));

var SvgCylinders = function SvgCylinders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25.652,
    viewBox: "0 0 19 25.652",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCylinders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cylinders.7e02322b.svg";
export { ForwardRef as ReactComponent };